import 'globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($('#filterForm select').length) {
            $('#filterForm select').selectpicker();
            $('#filterForm select').on('hide.bs.select', () => {
                $('#filterForm').trigger('submit');
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
